import { Analytics, Api } from '../shared/types';
import { apiv2Url } from './config';
import { postPromise } from './utils';

const flush = (
  actions: readonly Analytics.IdentifiableAction[]
): Promise<void> =>
  postPromise<Api.AnalyticsFlushRequest, void>(`${apiv2Url}/a`, {
    actions,
  });

export default {
  flush,
};
